import Constants from '../../utils/Constants';
import { CommonHttpHelper } from '../../utils/HttpHelper';

export const INITIAL_STATE = {
  isLoading: false,
  isLoaded: false,
  data: [],
  dataAsOptionsWithNames: [],
  message: ''
};

const NO_DATA_MESSAGE = 'The data could not be retrieved from the database.';

const getZones = (state, setState) => {
  if (state.isLoading !== true && state.isLoaded !== true && !state.message) {
    let newState = {
      ...state,
      isLoading: true,
      isLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const url = `/OrgUnit/usasorganization/zone`;
    CommonHttpHelper(url, 'GET')
      .then((data) => {
        if (!data) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          data.unshift({ zoneOrgUnitId: Constants.DEFAULT_ID, zoneOrgUnitName: '--' });
          newState = {
            ...newState,
            isLoading: false,
            isLoaded: true,
            data: data,
            dataAsOptionsWithNames: data.map((zone) => { return { id: zone.zoneOrgUnitId, name: zone.zoneOrgUnitName, lscOrgUnit: zone.lscOrgUnit } }),
            message: '',
          };
          setState(newState);
        }

      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isLoading: false,
          isLoaded: false,
          message: message
        });
      });
  }
};

const ZoneData = { INITIAL_STATE, getZones };

export default ZoneData;